export default __webpack_public_path__ + "static/media/contact.49f0aa1c.svg";